export enum TokenType {
  Retail = 0,
  Consumer = 1,
}
